import React from "react";
import { Button } from "@nextui-org/react";
const PrimaryButton = ({
  text,
  onClick,
  height,
  size,
  isDisabled,
  className,
  disabled = false,
  type,
  isLoading,
  startContent,
  endContent,
  variant,
  bgColor = "#4862EE",
  textColor = "#fff",
}) => {
  return (
    <div className={`${className}`}>
      <Button
        isLoading={isLoading}
        type={type}
        size={size}
        variant={variant}
        disabled={disabled}
        onClick={disabled === false ? onClick : null}
        style={
          disabled === false
            ? { backgroundColor: bgColor, color: textColor }
            : null
        }
        className={`${height !== "" ? `h-${height}` : "h-11"}  ${
          disabled === true
            ? "bg-[#D5DDE2] text-textColor cursor-not-allowed"
            : "bg-buttonColor text-white"
        }   text-center w-full mx-auto rounded-lg px-2 font-normal`}
        startContent={startContent}
        endContent={endContent}
      >
        {text}
      </Button>
    </div>
  );
};

export default PrimaryButton;
